import { ENV } from '@shared/config/env'
import { TelegramPlatform } from './TelegramPlatform'
import { WebPlatform } from './WebPlatform'
import type { PlatformService } from './types'

let instance: PlatformService | null = null

export const createPlatform = (): PlatformService => {
  if (instance) return instance
  instance = ENV.IS_WEB ? new WebPlatform() : new TelegramPlatform()
  return instance
}

export const getPlatform = (): PlatformService => instance ?? createPlatform()
